import { useState } from 'react';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';
import CommanForm from '../../components/FormController/Commanform';
import Button from '../../components/Ui/Button';
import ChangePasswordValidation from '../../yup/Auth/ChangeValidation';
import Errormessages from '../../components/ErrorMessage/Errormessages';
import { ChangePasswordAction } from '../../redux/Action/AuthAction';
import { useDispatch, useSelector } from 'react-redux';
import { ImageContainer } from '../../constants/ImagesConstants';
import { FormattedMessage, useIntl } from 'react-intl';
import { sidebarOpen } from '../../utils/Helper';

let { EyeImage, EyeView } = ImageContainer;

const ChangePassword = () => {
    const intl = useIntl();

    const dispatch = useDispatch<any>();
    const [showPassword, setShowPassword] = useState(false);
    const [showPassword2, setShowPassword2] = useState(false);
    const [showPassword3, setShowPassword3] = useState(false);
    const change_password = useSelector((state: any) => state.ChangePasswordState)
    // ChangePasswordState
    const { register, watch, setValue, errors, handleSubmit, trigger, setError, clearErrors } = CommanForm({
        validationSchema: ChangePasswordValidation, defaultValues: { password: '', new_password: '', confirm_password: "" }
    });

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const breadcrumbItems = [
        { title: 'dashboard', link: '/dashboard' },
        { title: 'Change_Password' },
    ];


    // const sidebarOpen = () => {
    //     $(".leftsidebar").addClass("active")
    // }

    const onsubmit = (payload: any) => {        
        const data = { old_password: payload.password, password: payload?.new_password }
        dispatch(ChangePasswordAction(data))
    }

    return (
        <>
            {/* <Header /> */}
            <div className='col-lg-9 serviceManagement'>

                <div className='dashboard bg-white'>
                    <div className='dashboardTop'>
                        <h2>
                            <button onClick={() => { sidebarOpen() }} type='button' className='btn mobileMenu p-1 d-lg-none'>
                                <span className="icon-menu-right"></span></button>
                            {<FormattedMessage id="change_password" />}</h2>
                        <Breadcrumb items={breadcrumbItems} />
                    </div>
                    <div className='dashboarcard'>
                        <div className='row'>
                            <div className='col-md-5'>
                                <form onSubmit={handleSubmit(onsubmit)}>
                                    <div className="mb-4 inputIcon">
                                        <label className="form-label"><FormattedMessage id="password" /></label>
                                        <input type={showPassword ? 'text' : 'password'} className="form-control"
                                               placeholder={intl.formatMessage({ id: 'enter_password' })}  {...register("password")}
                                        />
                                        <span className="iconLeft icon-lock"></span>
                                        <span className='iconRight viewPassword' onClick={() => setShowPassword(!showPassword)}
                                        >
                                            {showPassword ? (
                                                <img alt='hide' src={EyeView} />
                                            ) : (
                                                <img alt='view' src={EyeImage} />
                                            )}
                                        </span>
                                        <Errormessages name="password" errors={errors} />
                                    </div>
                                    <div className="mb-4 inputIcon">
                                        <label className="form-label"><FormattedMessage id="New_Password" /></label>
                                        <input type={showPassword2 ? 'text' : 'password'} className="form-control"
                                            placeholder={intl.formatMessage({ id: 'enter_new_password' })} {...register("new_password")}
                                        />
                                        <span className="iconLeft icon-lock"></span>
                                        <span className='iconRight viewPassword' onClick={() => setShowPassword2(!showPassword2)}>
                                            {showPassword2 ? (
                                                <img alt='hide' src={EyeView} />
                                            ) : (
                                                <img alt='view' src={EyeImage} />
                                            )}
                                        </span>
                                        <Errormessages name="new_password" errors={errors} />
                                    </div>
                                    <div className="mb-4 inputIcon">
                                        <label className="form-label"> <FormattedMessage id="Confirm_New_Password" /></label>
                                        <input type={showPassword3 ? 'text' : 'password'} className="form-control"
                                               placeholder={intl.formatMessage({ id: 'enter_confirm_password' })}  {...register("confirm_password")}
                                        />
                                        <span className="iconLeft icon-lock"></span>
                                        <span className='iconRight viewPassword' onClick={() => setShowPassword3(!showPassword3)}>
                                            {showPassword3 ? (
                                                <img alt='hide' src={EyeView} />
                                            ) : (
                                                <img alt='view' src={EyeImage} />
                                            )}
                                        </span>
                                        <Errormessages name="confirm_password" errors={errors} />
                                    </div>
                                    {/* <button type="submit" className="btn btn-fill w-100 mt-5">Update</button> */}
                                    <Button text= {intl.formatMessage({ id: 'update' })} type="submit" className="btn btn-fill w-100 mt-5" isLoading={change_password?.loading} />
                                </form>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </>
    )
}

export default ChangePassword